import { useAppLogo } from "helpers/useAppSetting";
import { CHECK_DISPLAY_CLS } from "../pifStyles";
import { formatDate } from "helpers/utils"
import { Link } from "react-router-dom"
import React from 'react';
import PropTypes from 'prop-types';

const BDS2 = ({pif, area}) => {
  const logo = useAppLogo();
  const {project, building, adaptation} = pif;
  const bds2 = area?.bds2 || {};

  const roofExtensionData = bds2?.roof_extensions || []
  const canopyData = bds2?.canopies || []
  const fasciaData = bds2?.fascias || []
  const frameOpeningData = bds2?.frame_openings || []
  const mezzanineData = bds2?.mezzanines || []
  const craneInformationData = bds2?.crane_informations || []

  const projectUrl = `/crm/projects/${project?.id}`

  return (
    <table className="tw-text-sm tw-mt-5">
      <tr>
        <td colSpan="2" className="tw-text-left tw-font-bold">
          Building Data Sheet 2
        </td>
        <td colSpan="6" className="tw-text-center">
          <div className="tw-text-2xl tw-font-bold tw-mb-2">PROJECT INFORMATION FORM</div>
        </td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          This building only: 2 of 3
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="2" className="tw-text-center">
          <img
            src={logo}
            alt="Logo Pebsteel"
            width="160"
            height="60"
            className="tw-object-contain tw-rounded-sm"
            style={{maxWidth: '100%'}}
          />
        </td>
        <td className="tw-font-bold">Quote No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{project?.q_number}</Link>
        </td>
        <td className="tw-font-bold">Rev No:</td>
        <td className="tw-text-primary-600">{adaptation.rev}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_order_entry"
                checked={!!(adaptation?.type === "change_order")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Order Entry</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_quotation"
                checked={!!(adaptation?.type === "revision")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Quotation</span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-font-bold">P/Job No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{building?.j_number}</Link>
        </td>
        <td className="tw-font-bold">CO#:</td>
        <td className="tw-text-primary-600">{adaptation.co}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <div>
              Bldg No: <span className="tw-text-primary-600">{building?.name}</span>
            </div>
            <div>
              Area No: <span className="tw-text-primary-600">{area?.id}</span>
            </div>
          </div>
          <h6 className="tw-text-center tw-my-2">This area only : Page 2 of 3</h6>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">12</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(roofExtensionData?.length > 0 || bds2.roof_extension_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>

          ROOF <br/> EXTENSION
        </td>
        <td colSpan="8">
        <div className="tw-text-sm tw-mt-2">
          <table>
            <thead className="tw-bg-slate-200 tw-text-slate-900">
              <tr className="tw-text-center" style={{height: "10px"}}>
                <th className="tw-border" rowSpan={2}>Location</th>
                <th className="tw-border" rowSpan={2}>Qty</th>
                <th className="tw-border" rowSpan={2}>Width (M)</th>
                <th className="tw-border" rowSpan={2}>Length (M)</th>
                <th className="tw-border" colSpan={2}>Soffit panel</th>
                <th className="tw-border" rowSpan={2}>Insulated</th>
                <th className="tw-border" rowSpan={2}>Description</th>
              </tr>
              <tr className="tw-text-center" style={{height: "10px"}}>
                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
              </tr>
            </thead>
            <tbody>
              {roofExtensionData && roofExtensionData.map((item, index) => (
                <tr key={index}>
                  <td className="tw-border">{item.location}</td>
                  <td className="tw-border">{item.qty}</td>
                  <td className="tw-border">{item.width}</td>
                  <td className="tw-border">{item.length}</td>
                  <td className="tw-border">{item.soffit_panel_by}</td>
                  <td className="tw-border">{item.soffit_panel_description}</td>
                  <td className="tw-border">{item.insulated}</td>
                  <td className="tw-border">{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-gap-2 tw-mt-3">
          <div className="tw-flex-1">
            <span dangerouslySetInnerHTML={{ __html: bds2.roof_extension_note }}></span>
          </div>
        </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">13</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(canopyData?.length > 0 || bds2.capony_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          CANOPY
        </td>
        <td colSpan="8">
        <div className="tw-text-sm tw-mt-2">
          <table>
            <thead className="tw-bg-slate-200 tw-text-slate-900">
              <tr className="tw-text-center" style={{height: "10px"}}>
                <th className="tw-border" rowSpan={2}>Location</th>
                <th className="tw-border" rowSpan={2}>Qty</th>
                <th className="tw-border" rowSpan={2}>Width (M)</th>
                <th className="tw-border" rowSpan={2}>Length (M)</th>
                <th className="tw-border" rowSpan={2}>Clear height (M)</th>
                <th className="tw-border" rowSpan={2}>Eave condition</th>
                <th className="tw-border" rowSpan={2}>Slope</th>
                <th className="tw-border" colSpan={3}>Roof panel</th>
                <th className="tw-border" colSpan={3}>Endwall panel</th>
                <th className="tw-border" colSpan={3}>Soffit panel</th>
              </tr>
              <tr className="tw-text-center" style={{height: "10px"}}>
                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>

                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>

                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>
              </tr>
            </thead>
            <tbody>
              {canopyData && canopyData.map((item, index) => (
                <tr key={index}>
                  <td className="tw-border">{item.location}</td>
                  <td className="tw-border">{item.qty}</td>
                  <td className="tw-border">{item.width}</td>
                  <td className="tw-border">{item.length}</td>
                  <td className="tw-border">{item.clear_height}</td>
                  <td className="tw-border">{item.eave_condition}</td>
                  <td className="tw-border">{item.slope}</td>

                  <td className="tw-border">{item.roof_panel_by}</td>
                  <td className="tw-border">{item.roof_panel_description}</td>
                  <td className="tw-border">{item.roof_panel_color}</td>

                  <td className="tw-border">{item.end_wall_panel_by}</td>
                  <td className="tw-border">{item.end_wall_panel_description}</td>
                  <td className="tw-border">{item.end_wall_panel_color}</td>

                  <td className="tw-border">{item.soffit_panel_by}</td>
                  <td className="tw-border">{item.soffit_panel_description}</td>
                  <td className="tw-border">{item.soffit_panel_color}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-gap-2 tw-mt-3">
          <div className="tw-flex-1">
            <span dangerouslySetInnerHTML={{ __html: bds2.capony_note }}></span>
          </div>
        </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">14</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(fasciaData?.length > 0 || bds2.fascia_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          FASCIA
        </td>
        <td colSpan="8">
        <div className="tw-text-sm tw-mt-2">
          <table>
            <thead className="tw-bg-slate-200 tw-text-slate-900">
              <tr className="tw-text-center" style={{height: "10px"}}>
                <th className="tw-border" rowSpan={2}>Location</th>
                <th className="tw-border" rowSpan={2}>Qty</th>
                <th className="tw-border" rowSpan={2}>Type</th>
                <th className="tw-border" rowSpan={2}>Height (M)</th>
                <th className="tw-border" rowSpan={2}>Length (M)</th>
                <th className="tw-border" rowSpan={2}>Proj. (M)</th>

                <th className="tw-border" colSpan={3}>Fascia panel</th>
                <th className="tw-border" colSpan={3}>Soffit panel</th>
                <th className="tw-border" colSpan={3}>Backup panel</th>
              </tr>
              <tr className="tw-text-center" style={{height: "10px"}}>
                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>

                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>

                <td className="tw-border">By</td>
                <td className="tw-border">Description</td>
                <td className="tw-border">Color</td>
              </tr>
            </thead>
            <tbody>
              {fasciaData && fasciaData.map((item, index) => (
                <tr key={index}>
                  <td className="tw-border">{item.location}</td>
                  <td className="tw-border">{item.qty}</td>
                  <td className="tw-border">{item.fascia_type}</td>
                  <td className="tw-border">{item.height}</td>
                  <td className="tw-border">{item.length}</td>
                  <td className="tw-border">{item.proj}</td>

                  <td className="tw-border">{item.fasica_panel_by}</td>
                  <td className="tw-border">{item.fasica_panel_description}</td>
                  <td className="tw-border">{item.fasica_panel_color}</td>

                  <td className="tw-border">{item.soffit_panel_by}</td>
                  <td className="tw-border">{item.soffit_panel_description}</td>
                  <td className="tw-border">{item.soffit_panel_color}</td>

                  <td className="tw-border">{item.backup_panel_by}</td>
                  <td className="tw-border">{item.backup_panel_description}</td>
                  <td className="tw-border">{item.backup_panel_color}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-gap-2 tw-mt-3">
          <div className="tw-flex-1">
            <span dangerouslySetInnerHTML={{ __html: bds2.fascia_note }}></span>
          </div>
        </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">15</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(frameOpeningData?.length > 0 || bds2.frame_opening_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          FRAME <br/> OPENING
        </td>
        <td colSpan="8">
        <div className="tw-text-sm tw-mt-2">
          <table>
            <thead className="tw-bg-slate-200 tw-text-slate-900">
              <tr className="tw-text-center" style={{height: "10px"}}>
                <th className="tw-border" rowSpan={2}>Qty</th>
                <th className="tw-border" rowSpan={2}>Width (mm)</th>
                <th className="tw-border" rowSpan={2}>Height (mm)</th>
                <th className="tw-border" rowSpan={2}>For</th>
                <th className="tw-border" rowSpan={2}>Doors, window,…By</th>
                <th className="tw-border" rowSpan={2}>Location</th>
              </tr>
            </thead>
            <tbody>
              {frameOpeningData && frameOpeningData.map((item, index) => (
                <tr key={index}>
                  <td className="tw-border">{item.qty}</td>
                  <td className="tw-border">{item.width}</td>
                  <td className="tw-border">{item.height}</td>
                  <td className="tw-border">{item.frame_opening_for}</td>
                  <td className="tw-border">{item.door_window_by}</td>
                  <td className="tw-border">{item.location}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-gap-2 tw-mt-3">
          <div className="tw-flex-1">
            <span dangerouslySetInnerHTML={{ __html: bds2.frame_opening_note }}></span>
          </div>
        </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">16</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(mezzanineData?.length > 0 || bds2.mezzanine_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          MEZZANINE
        </td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-7">
              <div className="tw-flex tw-gap-2">
                <div>PEB to Supply :</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-between">
                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds2.mezzinine_peb_supply_cols)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Cols</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds2.mezzinine_peb_supply_beams)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Beams</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds2.mezzinine_peb_supply_joists)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Joists</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds2.mezzinine_peb_supply_deck)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Deck</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds2.mezzinine_peb_supply_handrails_mezz)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Handrails Mezz.</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2">
                <div>
                  <label className="tw-inline-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds2.mezzinine_apply_load_only)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Apply loads only</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.mezzinine_apply_load_only_specify}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-text-sm tw-mt-2">
            <table>
              <thead className="tw-bg-slate-200 tw-text-slate-900">
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className="tw-border" rowSpan={2}>Mz no</th>
                  <th className="tw-border" rowSpan={2}>DL (kN/m2)</th>
                  <th className="tw-border" rowSpan={2}>LL (kN/m2)</th>
                  <th className="tw-border" rowSpan={2}>Coll (kN/m2)</th>
                  <th className="tw-border" rowSpan={2}>Area (m2)</th>
                  <th className="tw-border" rowSpan={2}>Clearance (mm)</th>
                  <th className="tw-border" colSpan={2}>Floor</th>
                  <th className="tw-border" rowSpan={2}>Stair Type</th>
                  <th className="tw-border" rowSpan={2}>Qty</th>
                  <th className="tw-border" rowSpan={2}>Width (mm) (IN/IN ofStringer)</th>
                  <th className="tw-border" colSpan={2}>Landing</th>
                  <th className="tw-border" rowSpan={2}>Tread Type</th>
                  <th className="tw-border" rowSpan={2}>Hand Rail</th>
                </tr>
                <tr className="tw-text-center">
                  <th className="tw-border">Type</th>
                  <th className="tw-border">Total thickness (mm)</th>

                  <th className="tw-border">Mid</th>
                  <th className="tw-border">Top</th>
                </tr>
              </thead>
              <tbody>
                {mezzanineData && mezzanineData.map((item, index) => (
                  <tr key={index}>
                    <td className="tw-border">{item.mz_no}</td>
                    <td className="tw-border">{item.dl}</td>
                    <td className="tw-border">{item.ll}</td>
                    <td className="tw-border">{item.coll}</td>
                    <td className="tw-border">{item.area}</td>
                    <td className="tw-border">{item.clearance}</td>
                    <td className="tw-border">{item.floor_type}</td>
                    <td className="tw-border">{item.floor_t}</td>
                    <td className="tw-border">{item.stair_type}</td>
                    <td className="tw-border">{item.qty}</td>
                    <td className="tw-border">{item.width}</td>
                    <td className="tw-text-center tw-border">
                      <input
                        type="checkbox"
                        name={`landing_mid_${item.id}`}
                        checked={!!(item.landing_mid)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                    </td>
                    <td className="tw-text-center tw-border">
                      <input
                        type="checkbox"
                        name={`landing_top_${item.id}`}
                        checked={!!(item.landing_top)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                    </td>
                    <td className="tw-border">{item.tread_type}</td>
                    <td className="tw-border">{item.hand_rail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-flex tw-gap-2 tw-mt-3 tw-mb-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds2.mezzanine_note }}></span>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds2.mezzinine_concrete_floor_thickness)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Is Concrete floor thickness included finished floor?</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Finish floor thickness (mm):</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.mezzinine_finish_floor_thickness}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2 tw-items-center">
            <div>Edge of mezzanine slab is expanded to out of :</div>
            <div className="tw-flex-1">
              <span className="tw-text-primary-600">{bds2.mezzanine_edge_slab}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">17</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(bds2?.roof_monitor_width || bds2?.roof_monitor_height || bds2.roof_monitor_slope || bds2.roof_monitor_eave_condition || bds2.roof_monitor_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          ROOF <br/> MONITOR
        </td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Width at throat (mm):</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.roof_monitor_width}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Height (mm):</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.roof_monitor_height}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Roof Slope:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.roof_monitor_slope}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Eave Condition:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.roof_monitor_eave_condition}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-8">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Roof panel & color:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.roof_monitor_panel_and_color}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-3 tw-items-center">
            <div>Wall Condition:</div>
            <div className="tw-flex-1">
              <span className="tw-text-primary-600">{bds2.roof_monitor_wall_condition}</span>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds2.roof_monitor_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">18</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(bds2?.ridge_vent_rv_type || bds2.ridge_vent_non_standard || bds2.ridge_vent_qty || bds2.ridge_vent_length || bds2.ridge_vent_roof_panel || bds2.ridge_vent_color || bds2.ridge_vent_remark || bds2.ridge_vent_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          RIDGE VENT
        </td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div>
              <div className="tw-flex tw-gap-2">
                <div>RV Type:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.ridge_vent_rv_type}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1 tw-items-center tw-mt-2 tw-ml-3">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds2.ridge_vent_non_standard)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>NON-STANDARD</span>
              </label>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-3">
            <div>
              <div className="tw-mb-1">Quantity:</div>
              <span className="tw-text-primary-600">{bds2.ridge_vent_qty}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Length:</div>
              <span className="tw-text-primary-600">{bds2.ridge_vent_length}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Roof panel:</div>
              <span className="tw-text-primary-600">{bds2.ridge_vent_roof_panel}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Color:</div>
              <span className="tw-text-primary-600">{bds2.ridge_vent_color}</span>
            </div>
            <div className="tw-flex-1">
              <div className="tw-mb-1">Remark:</div>
              <span className="tw-text-primary-600">{bds2.ridge_vent_remark}</span>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds2.ridge_vent_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">19</td>
        <td className="tw-font-bold tw-text-center">
          <div className="tw-mb-3">
            <input
              type="checkbox"
              checked={!!(craneInformationData?.length > 0 || bds2.crane_information_note)}
              readOnly
              className={CHECK_DISPLAY_CLS}
            />
          </div>
          CRANE INFORMATION
        </td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div>Scope of Supply:</div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds2.crane_only_apply_loads)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Only Apply Loads,</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds2.crane_beams_brackets)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Crane Beams & Brackets,</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds2.crane_rails)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Rails,</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds2.crane_system)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Crane system,</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds2.crane_bracket_only)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Bracket only,</span>
                </label>

              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div>
              <div className="tw-flex tw-gap-2 tw-mb-3 tw-items-center">
                <div>Power Supply. Volts:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.crane_power_supply_volt}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-mb-3 tw-items-center">
                <div>Hz:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.crane_hz}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-mb-3 tw-items-center">
                <div>Phases:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.crane_phase}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-mb-3 tw-items-center">
                <div>Manufacturer:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds2.crane_manufacturer}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-text-sm tw-mt-2">
            <table>
              <thead className="tw-bg-slate-200 tw-text-slate-900">
                <tr className="tw-text-center" style={{height: "10px"}}>
                  <th className="tw-border" rowSpan={2}>No.</th>
                  <th className="tw-border" rowSpan={2}>Crane Type</th>
                  <th className="tw-border" colSpan={3}>Span</th>
                  <th className="tw-border" colSpan={3}>Run length</th>
                  <th className="tw-border" rowSpan={2}>Capacity (M.T)</th>
                  <th className="tw-border" rowSpan={2}>Wheel Load (kN)</th>
                  <th className="tw-border" rowSpan={2}>Wheel Base (mm)</th>
                  <th className="tw-border" rowSpan={2}>Bumper (mm)</th>
                  <th className="tw-border" rowSpan={2}>Min. Hook Height</th>
                  <th className="tw-border" rowSpan={2}>Top of Crane Beam</th>
                  <th className="tw-border" rowSpan={2}>Bridge Weight (kg)</th>
                  <th className="tw-border" rowSpan={2}>Trolley Weight (kg)</th>
                  <th className="tw-border" colSpan={2}>Operaion</th>
                </tr>
                <tr className="tw-text-center">
                  <th className="tw-border">W1 (m)</th>
                  <th className="tw-border">From (GL)</th>
                  <th className="tw-border">To (GL)</th>

                  <th className="tw-border">(m)</th>
                  <th className="tw-border">From (GL)</th>
                  <th className="tw-border">To (GL)</th>

                  <th className="tw-border">Pendant</th>
                  <th className="tw-border">Cab</th>
                </tr>
              </thead>
              <tbody>
                {craneInformationData && craneInformationData.map((item, index) => (
                  <tr key={index}>
                    <td className="tw-border">{item.crane_sr}</td>
                    <td className="tw-border">{item.crane_type}</td>
                    <td className="tw-border">{item.span_w1}</td>
                    <td className="tw-border">{item.span_from_gl}</td>
                    <td className="tw-border">{item.span_to_gl}</td>
                    <td className="tw-border">{item.run_length}</td>
                    <td className="tw-border">{item.run_length_from_gl}</td>
                    <td className="tw-border">{item.run_length_to_gl}</td>
                    <td className="tw-border">{item.capacity}</td>
                    <td className="tw-border">{item.wheel_load}</td>
                    <td className="tw-border">{item.wheel_base}</td>
                    <td className="tw-border">{item.bumper}</td>
                    <td className="tw-border">{item.min_hook_height}</td>
                    <td className="tw-border">{item.top_of_crane_beam}</td>
                    <td className="tw-border">{item.bridge_weight}</td>
                    <td className="tw-border">{item.trolley_weight}</td>

                    <td className="tw-border tw-text-center">
                      <input
                        type="checkbox"
                        checked={!!(item.operation_pendant)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                    </td>
                    <td className="tw-border tw-text-center">
                      <input
                        type="checkbox"
                        checked={!!(item.operation_cab)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-flex tw-gap-2 tw-mt-3 tw-mb-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds2.crane_information_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">20</td>
        <td className="tw-font-bold tw-text-center">ATTACHED</td>
        <td colSpan="8">
          <div className="tw-flex tw-justify-around">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(bds2.attached_for_this_building)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For This Building/ Area Only,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(bds2.attached_bldg_data_sheet3)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>BLDG.Data Sheet 3,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(bds2.attached_bldg_data_sheet4)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>BLDG.Data Sheet 4,</span>
            </label>
          </div>
        </td>
      </tr>
    </table>
  )
};

BDS2.propTypes = {
  pif: PropTypes.object.isRequired,
  area: PropTypes.array.isRequired
}

export default BDS2;
